// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__sCE1v","list":"styles_list__C9xv2"};